//
import { useTranslation } from 'react-i18next'

//
import { formatMoney } from 'common'

import { GetBenefitUsageDetailsTotalUsage } from 'core/application/adminDashboard/reimbursements/perks/getBenefitUsageDetails'

import { Card } from 'common/components'

import { StatisticCard } from '../../../../adminDashboard/common'

//
import './totalAllowanceStatistic.less'

type TotalAllowanceStatisticProps = {
  data: GetBenefitUsageDetailsTotalUsage
  offerSameAllowance: boolean
}

function TotalAllowanceStatistic({ data, ...props }: TotalAllowanceStatisticProps) {
  const { t } = useTranslation()
  return (
    <div className="w-100 h-100 pb-16">
      <Card className="h-100">
        <div className="total-allowance__wrap">
          <h5 className="mb-16">{t('ee-dashboard.home.statistics.total-allowance-title')}</h5>
          <StatisticCard
            data={[
              {
                type: 'Data',
                value: (data.allowanceUsed / data.totalAllowance) * 100,
                color: data.color,
              },
            ]}
            statistics={{
              title: data.categoryName,
              content: formatMoney(data.percentageUsed, false),
            }}
            allowance={{
              spent: data.allowanceUsed,
              total: data.totalAllowance,
            }}
            width={180}
            height={180}
            offerSameAllowance={props.offerSameAllowance}
          />
        </div>
      </Card>
    </div>
  )
}

export default TotalAllowanceStatistic
